import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ChangeBgIcon from '@wix/da-ds/pkg/Icons/24x24/ChangeBg';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
var EditBackgroundButton = function (_a) {
    var deviation = _a.deviation, currentBackgroundId = _a.currentBackgroundId, onInitialize = _a.onInitialize, showBackgroundPicker = _a.showBackgroundPicker, isBackgroundsPopupOpen = _a.isBackgroundsPopupOpen;
    var t = useTranslation().t;
    useEffect(function () {
        onInitialize();
    }, [onInitialize]);
    var onClick = useCallback(function () {
        if (isBackgroundsPopupOpen) {
            return;
        }
        showBackgroundPicker(deviation);
    }, [deviation, isBackgroundsPopupOpen, showBackgroundPicker]);
    return (React.createElement(ActionBarItemWrapper, { tooltip: t('deviation.backgrounds.change') },
        React.createElement(ActionBarEditButton, { onClick: onClick, biData: {
                evid: BiEventType.CHANGE_BACKGROUND_CLICK,
                itemid: deviation.deviationId,
                typeid: getDeviationResourceType(deviation),
                background_id: currentBackgroundId,
            } },
            React.createElement(ActionBarIcon, { icon: ChangeBgIcon }))));
};
EditBackgroundButton.displayName = 'EditBackgroundButton';
export default EditBackgroundButton;
//# sourceMappingURL=EditBackgroundButton.js.map